import styled from 'styled-components';
import { fontSize } from 'styles/mixins';
import { colors } from 'styles/variables';

interface MonthlyImageDownloadCountProps {
  count: number;
  limit: number;
}

const MonthlyImageDownloadCountStyled = styled.div`
  align-items: baseline;
  display: inline-flex;
  font-weight: 700;

  .label {
    ${fontSize(16)};
    margin-right: 10px;
  }

  .count {
    ${fontSize(20)};
    color: ${colors.primary};
  }
`

const MonthlyImageDownloadCount = (props: MonthlyImageDownloadCountProps) => (
  <MonthlyImageDownloadCountStyled>
    <div className='label'>月間DL数</div>
    <div className='count'>{props.count} / {props.limit}</div>
  </MonthlyImageDownloadCountStyled>
)

export default MonthlyImageDownloadCount;
